import React from 'react'
import NoticeEditor from '../../../rdw/NoticeEditor';
import { EditorState } from 'draft-js';

interface Prop {
  editorState: EditorState
}

const NoticeContent: React.FC<Prop> = (props) => {
  const { editorState } = props

  return (
    <React.Fragment>
      <NoticeEditor editorState={editorState} />
    </React.Fragment>
  )
}

export default NoticeContent
